import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import PlayListBefore from "@/baseui/playListBefore/playListBefore.vue";
export default defineComponent({
  name: "playList",
  props: {
    playList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var router = useRouter();
    /* 歌单点击事件 */

    var playListClick = function playListClick(id) {
      router.push("/main/playlistdetail/".concat(id));
    };

    return {
      router: router,
      playListClick: playListClick
    };
  },
  components: {
    PlayListBefore: PlayListBefore
  }
});